import script from "./ActivityReportForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivityReportForm.vue?vue&type=script&setup=true&lang=ts"

import "./ActivityReportForm.vue?vue&type=style&index=0&id=38f8bf15&scope=true&lang=scss"

const __exports__ = script;

export default __exports__